import { ArrowLeft, ArrowRight, Loader2, Sparkles } from "lucide-react";

/**
 * Step footer with three slots:
 *  - left: BACK (gold pill)
 *  - center: Save & Continue Later (gold text link)
 *  - right: NEXT or SUBMIT (gold pill)
 */
export default function StepFooter({
    onBack,
    onNext,
    onSave,
    backDisabled,
    saving = false,
    submitting = false,
    submitMode = false,
}) {
    return (
        <div className="mt-10 pt-6 border-t border-[#D4AF37]/15 grid grid-cols-3 items-center gap-3">
            <div className="flex justify-start">
                <button
                    onClick={onBack}
                    disabled={backDisabled}
                    className="btn-gold px-5 py-2.5 text-sm inline-flex items-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed uppercase tracking-wide"
                    data-testid="intake-back-btn"
                >
                    <ArrowLeft size={14} /> Back
                </button>
            </div>
            <div className="text-center">
                <button
                    onClick={onSave}
                    disabled={saving}
                    className="gold-text text-sm font-medium tracking-wide hover:text-[#F3E5AB] transition disabled:opacity-50"
                    data-testid="intake-save-btn"
                >
                    {saving ? "Saving…" : "Save & Continue Later"}
                </button>
            </div>
            <div className="flex justify-end">
                <button
                    onClick={onNext}
                    disabled={submitting}
                    className="btn-gold px-6 py-2.5 text-sm inline-flex items-center gap-2 uppercase tracking-wide"
                    data-testid={submitMode ? "intake-submit-btn" : "intake-next-btn"}
                >
                    {submitting ? (
                        <Loader2 size={14} className="animate-spin" />
                    ) : submitMode ? (
                        <>
                            <Sparkles size={14} /> Submit
                        </>
                    ) : (
                        <>
                            Next <ArrowRight size={14} />
                        </>
                    )}
                </button>
            </div>
        </div>
    );
}
